import { useMemo } from 'react';
import { useRedux } from '../../../../states/redux-state';
import { iExtraInfo, iDeviceDetails } from '../../../../shared/interfaces';

export const useTbs = (deviceIdOrList: string | string[]) => {
    const allLabels = useRedux((s) => s.general.extraInfo);
    const allDevices = useRedux((s) => s.devicesData.devicesDetails);

    const tbsLabelId = useMemo(() => {
        if (!allLabels) return null;
        return Object.values(allLabels as Record<string, iExtraInfo>).find((l) =>
            l.details?.name === 'To Be Sold | Scrapped' ||
            l.details?.name === 'To Be Sold'
        )?.details?.id;
    }, [allLabels]);

    const result = useMemo(() => {
        const checkIsTbs = (device: iDeviceDetails | undefined): boolean => {
            if (!device || !tbsLabelId || !device['extra-info']) return false;

            const val = device['extra-info'][tbsLabelId];

            if (typeof val === 'object' && val !== null) {
                return (val as any).boolean === true;
            }
            return val === 'true' || val === true;
        };

        if (typeof deviceIdOrList === 'string') {
            const device = allDevices?.get(deviceIdOrList);
            return {
                isTbs: checkIsTbs(device),
                tbsMap: null
            };
        }

        const map: Record<string, boolean> = {};
        if (Array.isArray(deviceIdOrList) && allDevices) {
            deviceIdOrList.forEach(id => {
                const device = allDevices.get(id);
                map[id] = checkIsTbs(device);
            });
        }

        return {
            isTbs: false,
            tbsMap: map
        };

    }, [allDevices, tbsLabelId, deviceIdOrList]);

    return result;
};